import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { applyUpdate } from '../../serviceWorkerRegistration';

// "A new version is available" -- shown when a deployed update is waiting.
// Reloading is safe mid-form: every answer is already saved on the device.
export default function UpdatePrompt() {
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const onUpdate = (e) => setRegistration(e.detail);
    window.addEventListener('wmf-sw-update', onUpdate);
    return () => window.removeEventListener('wmf-sw-update', onUpdate);
  }, []);

  if (!registration) return null;
  return (
    <div className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-md items-center gap-3 rounded-xl bg-slate-900 px-4 py-3 text-sm text-white shadow-lg">
      <RefreshCw className="h-4 w-4 shrink-0" />
      <span className="flex-1">A new version of the portal is available.</span>
      <button type="button" onClick={() => applyUpdate(registration)}
        className="rounded-md bg-white px-3 py-1.5 text-xs font-medium text-slate-900 hover:bg-slate-100">
        Reload
      </button>
    </div>
  );
}
